@if (visible()) {
  <div class="modal-overlay" [class.active]="isOpen()" [class.modal-rtl]="isRtl()">
    <div class="modal-container"
         [ngClass]="[size()]"
         [class.open]="isOpen()"
         (click)="$event.stopPropagation()">

      <!-- Close button on top-right -->
      <button type="button" class="close-btn" (click)="onCloseClick()">
        <i class="fa-solid fa-xmark"></i>
      </button>

      <!-- Icon badge on top-left -->
      @if (iconSrc()) {
        <img class="modal-icon-img" [src]="iconSrc()" alt="" />
      } @else if (icon()) {
        <div class="modal-icon-badge">
          <i [ngClass]="icon()"></i>
        </div>
      }

      <div class="modal-header">
        <h3 class="modal-title">{{ title() }}</h3>
      </div>

      <div class="modal-body">
        @if (message()) {
          <p class="modal-message">{{ message() }}</p>
        }
        <ng-content></ng-content>
      </div>

      @if (showFooter()) {
        <div class="modal-footer">
          <button type="button" class="cancel-btn" (click)="onCancelClick()">{{ cancelLabel() }}</button>
          <button type="button" class="confirm-btn" [disabled]="confirmDisabled()" (click)="onConfirmClick()">{{ confirmLabel() }}</button>
        </div>
      }
    </div>
  </div>
}
